import { Status } from '../types/EventMembership/Status';

const statusNames: Record<Status, string> = {
  [Status.Going]: 'Going',
  [Status.Interested]: 'Interested',
  [Status.NotGoing]: 'Not Going',
  [Status.Requested]: 'Requested',
  [Status.Denied]: 'Denied'
};

export const eventStatusName = (status: Status) => {
  return statusNames[status];
};
